import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import localeCl from '@angular/common/locales/es-CL';
import { registerLocaleData } from '@angular/common'; 

registerLocaleData(localeCl);
bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
